import { getFirstAvailable } from "helpers/commonHelpers";

interface ShippingPartyDetailsProps {
  data: any;
  showName?: boolean;
  withoutStyles?: boolean;
}

export default function ShippingPartyDetails({ data, showName = true, withoutStyles = false }: ShippingPartyDetailsProps) {
  const name = getFirstAvailable(data.address?.name, data.airport?.name, data.seaport?.name);
  const street = data.address?.street_address || "";
  const city = getFirstAvailable(data.address?.city_name, data.airport?.city_name, data.seaport?.city_name);
  const state = getFirstAvailable(data.address?.state_name, data.airport?.state_code, data.seaport?.state_code);
  const zip = getFirstAvailable(data.address?.zipcode, data.airport?.code, data.seaport?.un_locode);
  const country = getFirstAvailable(data.address?.country_name, data.airport?.country_name, data.seaport?.country_name);

  return (
    <div className={withoutStyles ? "" : "text-right"}>
      {showName && <div className="text-primary text-sm font-medium">{name}</div>}
      <div className={withoutStyles ? "" : "text-tertiary text-xs"}>
        {street && (
          <div>
            {street}
            {(city || state || zip) && ","}
          </div>
        )}
        {(city || state || zip) && (
          <div>
            {city}
            {city && state && ", "}
            {state}
            {(city || state) && zip && " "}
            {zip}
            {country && ","}
          </div>
        )}
        {country && <div>{country}</div>}
      </div>
    </div>
  );
}

ShippingPartyDetails.defaultProps = {
  showName: true,
  withoutStyles: false,
};
